module.exports = __webpack_public_path__ + "static/media/rectangle-shadow.26bcd83f.png";